import { store, getContext, withSyncEvent, getElement } from '@wordpress/interactivity'
import { MagazineRackContext, ScrollableRowContext } from './@types/interactivity'

store('ucomm/uconn-today-magazine-rack', {
  actions: {
    handleClick: withSyncEvent((evt: Event) => {
      const context = getContext<MagazineRackContext>()
      context.count++
      if (context.count === 1) {
        evt.preventDefault()
        context.isHidden = !context.isHidden
      }
      context.buttonText = 'See All Our Issues'
    }),
  }
})

store('ucomm/uconn-today-magazine-scrollable', {
  actions: {
    handleMouseDown: withSyncEvent((evt: MouseEvent) => {
      const { pageX } = evt;
      const { ref } = getElement()
      const context = getContext<ScrollableRowContext>()
      if (!ref) return;
      context.scrollableCursor = 'grabbing';
      context.isMouseDown = true
      context.scrollableStartX = pageX - ref.getBoundingClientRect().left
      context.scrollLeft = ref.scrollLeft
    }),
    handleMouseUp: () => {
      const { ref } = getElement()
      const context = getContext<ScrollableRowContext>()
      if (!ref) return;

      context.scrollableCursor = 'grab';
      context.isMouseDown = false
    },
    handleMouseMove: withSyncEvent((evt: MouseEvent) => {
      evt.preventDefault()
      const { isMouseDown, scrollableStartX, scrollLeft } = getContext<ScrollableRowContext>();
      if (!isMouseDown) return;

      const { ref } = getElement()
      if (!ref) return

      const x = evt.pageX - ref.getBoundingClientRect().left;
      const scroll = scrollLeft + (scrollableStartX - x)

      ref.scrollTo({
        left: scroll,
        behavior: 'instant'
      })
    }),
    handleMouseLeave: () => {
      const { ref } = getElement()
      const context = getContext<ScrollableRowContext>();
      if (!ref) return;
      context.scrollableCursor = 'default';
      context.isMouseDown = false
    },
    handleFocus: () => {
      const { ref } = getElement()
      if (!ref) return;

      const parentScrollableRow = ref.closest<HTMLElement>('.query-loop-wrapper .is-style-scrollable-row')
      if (!parentScrollableRow) return;

      const scroll = ref.offsetLeft - parentScrollableRow.offsetLeft

      parentScrollableRow.scrollTo({
        left: scroll,
        behavior: 'smooth'
      })
    },
    handleKeyDown: withSyncEvent((evt: KeyboardEvent) => {
      const key = evt.key
      const { ref } = getElement()
      if (!ref) return

      const parentScrollableRow = ref.closest<HTMLElement>('.query-loop-wrapper .is-style-scrollable-row')
      if (!parentScrollableRow) return;

      const nextTarget = ref.nextElementSibling as HTMLElement | null
      const hasNextLI = nextTarget?.tagName === 'LI'
      const prevTarget = ref.previousElementSibling as HTMLElement | null
      const hasPrevLI = prevTarget?.tagName === 'LI'

      if (key === 'ArrowRight' && hasNextLI) {
        parentScrollableRow.scrollTo({
          left: ref.offsetLeft + parentScrollableRow.offsetLeft,
          behavior: 'smooth'
        })
        nextTarget.focus()
      } else if (key === 'ArrowLeft' && hasPrevLI) {
        parentScrollableRow.scrollTo({
          left: prevTarget.offsetLeft - parentScrollableRow.offsetLeft,
          behavior: 'smooth'
        })
        prevTarget.focus()
      }
    }),
  },
})